import React from 'react';

/**
 * The DISC letter as a small outlined badge after a type name in a heading —
 * 果斷決策型 [D]. It takes the heading's colour and scales with its size, so it
 * sits in any heading without a stylesheet of its own (the public quiz pages
 * use it too).
 */
const DiscLetterBadge = ({ letter }: { letter?: string | null }) =>
  letter ? (
    <span
      className="disc-letter-badge"
      style={{
        display: 'inline-block',
        marginLeft: '0.4em',
        padding: '0 0.4em',
        border: '1px solid currentColor',
        borderRadius: 6,
        fontSize: '0.72em',
        fontWeight: 700,
        lineHeight: 1.45,
        verticalAlign: 'middle',
        opacity: 0.85
      }}
    >
      {letter}
    </span>
  ) : null;

export default DiscLetterBadge;
